import { Component, OnInit } from '@angular/core';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { CCCName, RoleLevel } from '../services/settingService/setting.enum';

@Component({
  selector: 'app-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss']
})
export class SideNavigationComponent implements OnInit {
 
  customize: boolean = true;
  expand: boolean = false;
 
  rolesAsssign: any[] = [];
  navItems: any[] = [];
  isOfficeAdmin: boolean;
  isOrganizationAdmin: boolean;
  isSuperAdmin: boolean;
  coreNames:string="";
  menuModulesList:any=[]=[];

  constructor(private _dataSharingService: DataSharingService) {

  }

  ngOnInit(): void {
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var menuModulesLists = this.menuModulesList.filter(x => x.mainModuleName == CCCName.Core);
     if (menuModulesLists.length > 0) {
       this.coreNames = menuModulesLists[0].orgModuleName;
     }
    //
    if (this.rolesAsssign.length > 0) {
      this.isOfficeAdmin = this.rolesAsssign.find(m => m.roleName == 'Office Admin') != undefined;
      this.isOrganizationAdmin = this.rolesAsssign.find(m => m.roleName == 'Organization Admin') != undefined;
      this.isSuperAdmin = this.rolesAsssign.find(m => m.roleName == 'Super Admin') != undefined;
    }
    //

    if(this.rolesAsssign.length > 0){
      var Superadmin=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      Superadmin= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
      if(Superadmin.length > 0){
       this.ManageFeilds();
       this.ManageSharedRole();
       this.ManageTemplateCategory();
       this.ManageOrganizationTemplateCategory();
       this.ManageAITemplates();
       this.ManageSNFDashboard();
       this.ManageMessageTemplates();
       //this.ManageMessageTemplates();
       this.ManageImportExport();
       //this.ManageLoginDetails();
        return;
      }

      var OrganizationAdmin=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      OrganizationAdmin= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OrganizationAdmin);
      if(OrganizationAdmin.length > 0){       
        this.ManageFeilds();   
        this.ManageSharedRole();
        this.ManageOrganizationTemplateCategory();
       // this.ManageTemplates();    
        this.ManageAITemplates();   
        this.ManageSNFDashboard();
        this.ManageMessageTemplates();
        this.ManageImportExport();
        return;
      }

      var OfficeAdmin=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      OfficeAdmin= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OfficeAdmin);
      if(OfficeAdmin.length > 0){        
        this.ManageFeilds();
        this.ManageSharedRole();
        this.ManageOrganizationTemplateCategory();
        //this.ManageTemplates();       
        this.ManageAITemplates(); 
        this.ManageSNFDashboard();
        this.ManageMessageTemplates();
        this.ManageImportExport();
        return;
      }    

      var User=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      User= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.User);
      if(User.length > 0){
        this.ManageTemplates();
        this.ManageAITemplates();
        this.ManageImportExport();
        return;
      }
    }   
  }
  
   // Show only Super admin / Organization Admin / OfficeAdmin
   ManageFeilds(){
    var ReqModel={
    id: '1',
    name : 'Customize',
    items :[
      {
        name: 'Fields',
        link: '/settings',
      },
      {
        name: 'Custom Field Group Types',
        link: 'subtype',
      },
      {
        name: 'Custom Field Tags Types',
        link: 'managetag',
      },
      {
        name: 'Relation Types',
        link: 'managetransactionroles',
      },
      {
        name: 'Task Statuses',
        link: 'managetaskstatus',
      },
      {
        name: 'Activity Statuses',
        link: 'manageactivitystatus',
      },
      {
        name: 'Custom Info Description',
        link: 'managecustominfostatus',
      },
      {
        name: 'Form Report Folders',
        link: 'managefolderform',
      },
      {
        name: 'Quick Web Forms',
        link: 'managefolderforms',
      },
      {
        name: 'NTA',
        link: 'managentacomorbidity',
      }
    ]
    } 
    this.navItems.push(ReqModel);
   }

   // Show For All Login
   ManageTemplates(){
    var ReqModel={
      id: '2',
      name : 'Templates',
      items :[
        {
          name: 'Stage Folders',
          link: 'managetemplates',
        },
        {
          name: 'Task List Templates',
          link: 'managetasktemplates',
        },
        {
          name: 'Single Task Templates',
          link: 'managesingletasktemplates',
        },       
        // {
        //   name: 'OCR Templates',
        //   link: 'manageOcrTemplate',
        // },
        {
          name: 'Email Templates',
          link: 'emailtemplate',
        },       
        // {
        //   name: 'NLP Template',
        //   link: 'manageQuestionTemplate',
        // },
        // {
        //   name: 'AI Automation Templates',
        //   link: 'manageAIAutomationTemplates',
        // },
        // {
        //   name: 'Import Records',
        //   link: 'import',
        // },        
      ] 
     }   
      this.navItems.push(ReqModel);    
   }

    // Show For All Login
    ManageImportExport(){
      var ReqModel={
        id: '2',
        name : 'API Mappings',
        items :[          
          {
            name: 'Upload by CSV',
            link: 'import',
          },
          // {
          //   name: "3rd Party API's ",
          //   link: 'thirdparty',
          // },
          {
            name: "Integrations",
            link: 'addthirdParty',
          },     
        ] 
       }   
        this.navItems.push(ReqModel);    
     }

    // Show For Office Login
    ManageMessageTemplates(){
      var ReqModel={
        id: '2',
        name : 'Templates',
        items :[
          {
            name: `${this.coreNames} Document Folders`,
            link: 'managetemplates',
          },
          // {
          //   name: 'Import Records',
          //   link: 'import',
          // },
          {
            name: 'Message Templates',
            link: 'messagetemplates',
          },          
          {
            name: 'Task List Templates',
            link: 'managetasktemplates',
          },
          {
            name: 'Single Task Templates',
            link: 'managesingletasktemplates',
          },          
          // {
          //   name: 'OCR Templates',
          //   link: 'manageOcrTemplate',
          // },
          {
            name: 'Email Templates',
            link: 'emailtemplate',
          }, 
          
              

          // {
          //   name: 'NLP Template',
          //   link: 'manageQuestionTemplate',
          // },          
        ] 
       }   
        this.navItems.push(ReqModel);    
     }

   // Show only Super admin
   ManageTemplateCategory(){
    var ReqModel={
      id: '3',
      name : 'Category',
      items :[          
        {
          name: 'All Master Categories',
          link: 'templatecategory',
        },
        {
          name: 'Template Categories',
          link: 'templatecategoryOrg',
        },
        {
         name: 'Task Category',
         link: 'managetaskcategory',
         }
        ],
     } 
     this.navItems.push(ReqModel);    
   }

   ManageOrganizationTemplateCategory(){
    var ReqModel={
      id: '3',
      name : 'Template Category',
      items :[        
        {
          name: 'Template Categories',
          link: 'templatecategoryOrg',
        },
        {
          name: 'AI Fields Categories',
          link: 'manageOcrTemplateCategory',
        },
        {
          name: 'AI Questions Categories',
          link: 'manageQuestionTemplateCategory',
        },
        ],
     } 
     this.navItems.push(ReqModel);    
   }

   
     // Show only Super admin
     ManageLoginDetails(){
      var ReqModel={
        id: '5',
        name : 'All Login Details',
        items :[          
          {
            name: 'Login Details',
            link: 'logindetails',
          }
          ],
       } 
       this.navItems.push(ReqModel);    
     }

   // Show only Organization Admin
   ManageSharedRole(){
    var ReqModel={
      id: '4',
      name : 'Shared Entity Settings',
      items :[          
        {
          name: 'Shared Roles',
          link: 'managesharedrole',
        },          
       ] 
      }
     this.navItems.push(ReqModel);    
   }


   ManageAITemplates(){
    var ReqModel={
      id: '22',
      name : 'AI Templates',
      items :[            
        {
          name: 'AI Field Templates',
          link: 'manageOcrTemplate',
        },              
        {
          name: 'AI Question Templates',
          link: 'manageQuestionTemplate',
        },
        {
          name: 'AI Automation Templates',
          link: 'manageAIAutomationTemplates',
        }, 
        {
          name: 'AI Automation Process Report',
          link: 'manageAutomationProcessReport',
        },  
        {
          name: 'System Prompts',
          link: 'systemprompts',
        }           
      ] 
     }   
      this.navItems.push(ReqModel);    
   }
   
   
   ManageSNFDashboard(){
    var ReqModel={
      id: '23',
      name : 'Customize Dashboard',
      items :[            
        {
          name: 'Widget Stages',
          link: 'managestageprocess',
        },              
             
      ] 
     }   
      this.navItems.push(ReqModel);    
   }

   
  expandNav(){
    this.expand = !this.expand
  }


  

  linkclick(link){    
    if(link.name == "My Profile"){
      sessionStorage.setItem('HeaderModuleName', link.name);   
      this._dataSharingService.sendSelectedModuleName(link.name);
    }   
  }

}


